import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { createNlsMiddleware } from 'lcc-state';
import { Biography } from './biography';
import { css } from '../css/member.m.css';
const factory = create({
    nls: createNlsMiddleware('roster'),
    theme
}).properties();
export const Member = factory(({ properties, middleware: { nls, theme } }) => {
    const { members, size, showProfileLink } = properties();
    const { messages: { edit_your_profile = '' } } = nls();
    const themedCss = theme.classes(css);
    const classesBySize = {
        large: {
            avatar: ['col-xs-3', 'col-sm-4', 'col-md-3', 'col-lg-3'],
            bio: ['col-xs-10', 'col-sm-10', 'col-md-9', 'col-lg-9'],
            actions: ['col-xs-9', 'col-sm-8', 'col-md-6', 'col-lg-4']
        },
        medium: {
            avatar: ['col-xs-3', 'col-sm-4', 'col-md-3', 'col-lg-3'],
            bio: ['col-xs-9', 'col-sm-8', 'col-md-8', 'col-lg-5'],
            actions: ['col-xs-9', 'col-sm-8', 'col-md-6', 'col-lg-4']
        },
        small: {
            avatar: ['col-xs-2', 'col-sm-2', 'col-md-3', 'col-lg-3'],
            bio: ['col-xs-10', 'col-sm-10', 'col-md-9', 'col-lg-9'],
            actions: ['col-xs-9', 'col-sm-8', 'col-md-6', 'col-lg-4']
        }
    };
    const containerClasses = size && size in classesBySize ? classesBySize[size] : classesBySize.large;
    const memberList = members.map((member) => {
        const avatar = member.has_avatar ? [v('img', { src: member.avatar })] : [];
        const memberRow = v('div', { classes: ['row'], xqa: 'roster-item' }, [
            v('div', { classes: containerClasses.avatar }, [v('span', { classes: themedCss.avatar }, avatar)]),
            v('div', { classes: containerClasses.bio }, [
                v('div', { classes: themedCss.details }, [
                    v('h3', { innerHTML: member.fullname }),
                    w(Biography, { biography: member.bio })
                ])
            ]),
            showProfileLink
                ? v('div', { classes: [themedCss.actionContainer, ...containerClasses.actions] }, [
                    v('ul', { classes: [themedCss.userActions] }, [
                        v('li', { classes: 'profile' }, [
                            v('a', {
                                classes: ['lp-link'],
                                href: '/am/@@profile',
                                innerHTML: edit_your_profile
                            })
                        ])
                    ])
                ])
                : null
        ]);
        if (size && size === 'small') {
            return v('div', { classes: [themedCss.classmate, 'col-xs-12', 'col-sm-6', 'col-md-4', 'col-lg-3'] }, [
                memberRow
            ]);
        }
        return memberRow;
    });
    return v('div', {}, memberList);
});
